import styled from 'styled-components';
import { SEMANTIC_COLORS } from '../../../constant/unit/color';
export const S = {
    Wrapper: styled.div `
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    padding: 30px;
    color: ${SEMANTIC_COLORS.DEFAULT_TEXT};

    background: ${SEMANTIC_COLORS.DEFAULT_PAGE_BACKGROUND};
  `,
    Block: styled.div `
    margin-top: 8px;
  `,
    Title: styled.p `
    font-size: 15px;
    font-weight: 500;
  `,
    Config: styled.p `
    font-size: 12px;
    word-wrap: break-word;
  `,
};
